<template>
  <div class="email-container">
    <!-- 头部导航 -->
    <div class="header-box">
      <div class="come-back" @click="$router.back()">
        <van-icon name="arrow-left" />
      </div>
      <div class="title-box">Premium Member</div>
      <div class="placeholder" />
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <div class="welcome-title">Welcome to Magicube Premium</div>

      <div class="welcome-message">
        <p>
          Thank you for your trust and support. Your subscription has been
          successfully activated. From now on, you will have
        </p>
        <p>
          access to exclusive benefits for MakoNovel Premium members and a
          smoother experience with fewer ads.
        </p>
      </div>

      <div class="email-display">
        {{ userEmail }}
      </div>

      <div class="redemption-note">
        <p>
          💡 "The redemption code will be sent to your email within 7 business
          days. Please keep an eye on your inbox."
        </p>
      </div>

      <div class="contact-section">
        <div class="contact-title">Contact Us</div>

        <div class="contact-info">
          <div class="contact-item">
            <span class="email-address">magicubegroup@gmail.com</span>
          </div>
        </div>

        <div class="contact-note">
          "We do not respond directly here. Please contact us through the
          specific email indicated above for your region."
        </div>
      </div>
    </div>

    <!-- 底部页脚 -->
    <div class="footer">
      <div class="footer-note">
        This is an automated email, please do not reply to this message.
      </div>
      <div class="copyright">© 2025 MakoNovel. All rights reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailConfirmation',
  data() {
    return {
      userEmail: 'user@example.com', // 这里应该从路由参数或store中获取用户邮箱
    }
  },
  mounted() {
    // 从路由参数获取邮箱
    if (this.$route.query.email) {
      this.userEmail = this.$route.query.email
    }

    // 或者从用户信息中获取
    // if (this.$store.state.user.email) {
    //   this.userEmail = this.$store.state.user.email
    // }
  },
  methods: {
    // 可以添加重新发送邮件的方法
    resendEmail() {
      // 调用API重新发送邮件
      console.log('重新发送邮件到:', this.userEmail)
    },
  },
}
</script>

<style lang="scss" scoped>
.email-container {
  background-color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  min-height: 100vh;

  .header-box {
    align-items: center;
    background: #fff;
    display: flex;
    font-size: 18px;
    height: 44px;
    justify-content: space-between;
    width: 100vw;
    padding: 0 16px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999999;

    .come-back {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      height: 44px;
      justify-content: space-around;
      width: 44px;

      .van-icon {
        font-size: 24px;
        color: #333;
      }
    }

    .title-box {
      color: #212121;
      font-family: PingFangSC, 'PingFang SC';
      font-size: 18px;
      font-weight: 500;
      height: 44px;
      left: 50%;
      line-height: 44px;
      position: absolute;
      transform: translateX(-50%);
    }

    .placeholder {
      visibility: hidden;
      width: 44px;
    }
  }

  .main-content {
    background-color: #f8f9fa;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    padding: 54px 20px 20px;

    .welcome-title {
      color: #333;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
      text-align: center;
    }

    .welcome-message {
      margin-bottom: 25px;

      p {
        color: #666;
        font-size: 14px;
        line-height: 1.6;
        text-align: left;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .email-display {
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      color: #333;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 25px;
      padding: 15px;
      text-align: center;
    }

    .redemption-note {
      background-color: #fff3cd;
      border: 1px solid #ffeeba;
      border-radius: 8px;
      color: #856404;
      font-size: 14px;
      font-style: italic;
      line-height: 1.5;
      margin-bottom: 25px;
      padding: 15px;
    }

    .contact-section {
      background-color: #fff;
      border-radius: 8px;
      padding: 20px;

      .contact-title {
        color: #333;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 20px;
      }

      .contact-info {
        margin-bottom: 15px;

        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          .contact-label {
            color: #666;
            font-size: 14px;
            min-width: 80px;
          }

          .email-address {
            color: #ff1979;
            font-size: 14px;
            font-weight: 500;
          }

          .contact-value {
            color: #666;
            font-size: 14px;
          }
        }
      }

      .contact-note {
        color: #999;
        font-size: 13px;
        font-style: italic;
        line-height: 1.5;
        margin-top: 15px;
      }
    }
  }

  .footer {
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
    text-align: center;

    .footer-note {
      color: #999;
      font-size: 13px;
      line-height: 1.5;
      margin-bottom: 10px;
    }

    .copyright {
      color: #999;
      font-size: 12px;
    }
  }
}

// 响应式调整
@media screen and (max-width: 768px) {
  .email-container .main-content {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media screen and (max-width: 480px) {
  .email-container .welcome-title {
    font-size: 18px;
  }

  .email-container .main-content .email-display {
    font-size: 14px;
    padding: 12px;
  }
}
</style>
